import { Color } from "../../defines/colors"
import { MapID } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position } from "../../defines/types"
import { mapIDToString } from "../../utils/map"
import { Entity } from "../entity"

export class LockedDoor extends Entity {
  private _canBeUnlocked: boolean
  private _unlockDate: string

  constructor(
    public target: MapID,
    position: Position,
    unlockDate: string, // "YYYY-MM-DD"
    canBeUnlocked: boolean
  ) {
    super(
      position,
      true,
      {
        symbol: [Symbol.LOCKED_DOOR],
        light: Color.LOCKED_DOOR,
        dark: Color.LOCKED_DOOR_DARK,
      },
      "Door to " + mapIDToString(target) + " (locked)"
    )

    this._canBeUnlocked = canBeUnlocked
    this._unlockDate = unlockDate
  }

  canBeUnlocked(): boolean {
    return this._canBeUnlocked
  }

  getUnlockDate(): string {
    return this._unlockDate
  }
}
